module.exports = __webpack_public_path__ + "static/media/LOGO.370a789c.svg";